module.exports = __webpack_public_path__ + "static/media/layout2.fe2d0e3c.jpg";